import _ from 'lodash';
import pluralize from 'pluralize';

let itemsPerRow = 6;

class DashboardController {
  constructor($translate, dashboardService, tilesService, purchasingAccountsService, localStorageService) {
    this.$translate = $translate;
    this.loading = true;
    this.hasData = false;
    this.tiles = tilesService.getTranslatedTiles();
    this.rows = [];
    this.totalCount = 0;
    this.localStorageService = localStorageService;
    dashboardService.getCounts().then(this.onDashboardComplete.bind(this), this.onDashboardFailed.bind(this));
    this.customerId = JSON.parse(sessionStorage.getItem('dimsum.user')).customerId;
    purchasingAccountsService.getPurchasingAccountsByCustomerId(this.customerId).then(this.onPurchasingAccountSuccess.bind(this), this.onPurchasingAccountFail.bind(this));
  }

  onPurchasingAccountSuccess(response){
    this.localStorageService.set('purchasingAccountData', response.data[0]);
  }

  onPurchasingAccountFail(error){
    console.warn(error);
  }

  onDashboardComplete(response) {
    this.setRowsFromResponse(response);
    this.loading = false;
  }

  onDashboardFailed() {
    this.error = true;
    this.loading = false;
  }

  setRowsFromResponse(response) {
    let data = response.data;

    if (data.success) {
      this.createRows(data);
    } else {
      this.onDashboardFailed();
    }
  }

  createRows(data) {
    var row = [];

    if (this.userHasData(data)) {
      this.hasData = true;
    } else {
      return;
    }

    this.tiles.forEach((tile) => {
      let index = this.findMatchingContentIndex(tile, data.content);

      this.bindContentToTile(tile, data.content[index]);
      this.bindAggregateToTile(tile, data.aggregates[index]);

      if (!this.isCourseTileWithZeroCount(tile)) {
        row.push(tile);
      }

      if (row.length % itemsPerRow === 0) {
        this.rows.push(row);
        row = [];
      }
    });

    this.addLastRowToRows(row);
  }

  findMatchingContentIndex(tile, content) {
    let name = tile.name;
    let currentCountIndex = _.findIndex(content, (count) => {
      return count.name === name;
    });
    return currentCountIndex;
  }

  bindContentToTile(tile, content) {
    let count = content.count || 0;
    tile.count = count;
  }

  isCourseTileWithZeroCount(tile) {
    return (tile.name === 'courses' && tile.count === 0);
  }

  bindAggregateToTile(tile, aggregate) {
    let href = aggregate.model === 'error' ? '/errors' : `/databrowser/${pluralize(aggregate.model)}`;
    tile.href = href;
  }

  addLastRowToRows(row) {
    if (row.length) {
      this.rows.push(row);
    }
  }

  userHasData(data) {
    return (data.content.length > 0);
  }

  isEmptyDistrict(tile) {
    return (tile.label.toLowerCase() === 'districts' && tile.count === 0);
  }
}

DashboardController.$inject = ['$translate', 'dashboardService', 'tilesService', 'purchasingAccountsService', 'localStorageService'];

export
default DashboardController;



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.controller.js